import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const DebriefMenu = () => {
  const game = useSelector((state) => state.game);
  const { t } = useTranslation();

  const links = [
    { name: 'Dancefloor', url: '/debrief/dancefloor' },
    { name: 'Satisfaction', url: '/debrief/satisfaction' },
    { name: 'First Offer', url: '/debrief/first' },
    { name: 'Bargaining Zone', url: '/debrief/bargaining' },
    { name: 'Leaderboard', url: '/debrief/leaderboard' },
  ];

  const renderLinks = links.map((l, li) => (
    <NavLink
      key={'dm-' + li}
      to={`/games/${game.data._id}${l.url}`}
      className={({ isActive }) =>
        isActive ? 'btn btn-primary btn-sm ms-3' : 'btn btn-link btn-sm ms-3'
      }>
      {l.name}
    </NavLink>
  ));

  return (
    <div>
      <div className='d-inline-block'>{renderLinks}</div>
      <button
        className='btn btn-sm btn-outline-primary ms-3'
        onClick={() => window.location.reload()}>
        <FontAwesomeIcon icon='redo-alt' />
      </button>
    </div>
  );
};

export { DebriefMenu };
